/**
 * Utility function to chunk an array into smaller arrays
 * @param array Array to chunk
 * @param size Size of each chunk
 * @returns An array of chunked arrays
 */
export const chunk = <T>(array: T[], size = 1) => {
  if (size <= 0) {
    return [];
  }
  const chunkSize = Math.round(size);
  return array.reduce<T[][]>((arr, item, index) => {
    return index % chunkSize === 0
      ? [...arr, [item]]
      : [...arr.slice(0, -1), [...arr.slice(-1)[0], item]];
  }, []);
};
